<template>
  <div>
    <div class="table-title">
      <div>
        退费单号：<span>{{ resData.activity_fee_refund_no }}</span>
      </div>
      &nbsp;&nbsp;
      <div>
        生成时间：<span>{{ resData.create_time }}</span>
      </div>
      &nbsp;&nbsp;
      <div>
        退费状态：<strong
          :style="{
            color: resData.pay_status === PAY_STATUS_FAIL ? 'red' : 'blue',
          }"
          >{{ resData.pay_status_text }}</strong
        >
      </div>
    </div>
    <!-- 活动退费 -->
    <el-row class="mt-5">
      <el-col style="border: 1px solid #ddd">
        <div class="table-title">
          <div>
            活动费退费商品：<span
              >共{{ resData.activity_goods_num }}件，&nbsp;&nbsp; ￥{{
                resData.activity_goods_amount
              }}元</span
            >
          </div>
        </div>
        <div v-if="resData.activity_goods" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            :data="resData.activity_goods"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="order_id"
              label="订单ID"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_img"
              label="商品图片"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    style="width: 100%; height: 100%"
                    :src="scope.row.goods_img"
                  />
                </div> </template
            ></el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="co_val"
              label="颜色"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="si_val"
              label="尺码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku编号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="num"
              label="商品数量"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_fee"
              label="单件活动费退费金额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_time"
              label="活动时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_name"
              label="活动名称"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_id"
              label="活动ID"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_type_text"
              label="活动类型"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="activity_fee_amount"
              label="活动费退费总额"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
    <!-- 非支付失败收款人信息 -->
    <el-row class="mt-5">
      <el-col style="border: 1px solid #ddd">
        <div class="table-title">
          <div>收款人信息</div>
          <!-- 支付失败并且支付方式不等于分账时 -->
          <el-button
            v-if="isShowAgainActivateBtn"
            style="margin-left: auto"
            type="primary"
            @click="handleAgainActivate()"
            >重新激活</el-button
          >
        </div>
        <div v-if="updateUpload" style="margin-bottom: 0">
          <el-table
            v-if="
              !(
                resData.pay_status === PAY_STATUS_FAIL &&
                resData.pay_tool === PAY_TOOL_SUB_ACCOUNT
              )
            "
            :data="payInfoData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <!-- 支付失败并且支付方式不等于分账时 -->
            <el-table-column
              v-if="
                resData.pay_status === PAY_STATUS_FAIL &&
                resData.pay_tool !== PAY_TOOL_SUB_ACCOUNT
              "
              label="选择"
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="pay_contact"
              label="收款人名称"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_bank"
              label="收款银行"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="cnap"
              label="收款银行支行"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="pay_account"
              label="收款账号"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              v-if="
                (resData.pay_status === PAY_STATUS_UNPAID &&
                  resData.pay_tool === PAY_TOOL_PAY) ||
                (resData.pay_status === PAY_STATUS_PAID &&
                  resData.pay_tool !== PAY_TOOL_SUB_ACCOUNT)
              "
              prop="address"
              :label="`付款回执（${
                resData.pay_status === PAY_STATUS_PAID
                  ? filesImg.length > 0
                    ? filesImg.length
                    : filesImgClone.length
                  : filesImg.length
              })张）`"
              align="center"
            >
              <div class="flex-center">
                <div
                  v-if="resData.pay_status === PAY_STATUS_PAID"
                  style="display: flex"
                >
                  <div
                    v-for="(item, index) in filesImgClone"
                    :key="index"
                    class="img-box"
                  >
                    <img
                      v-viewer
                      style="width: 100%; height: 100%"
                      :src="item"
                    />
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    v-for="(item, index) in filesImg"
                    :key="index"
                    class="img-box"
                  >
                    <div
                      class="el-icon-close img-close"
                      @click="delImg(index)"
                    />
                    <img
                      v-viewer
                      style="width: 100%; height: 100%"
                      :src="item"
                    />
                  </div>
                </div>
                <el-upload
                  :action="action"
                  style="display: inline-block; margin-right: 10px"
                  multiple
                  :show-file-list="false"
                  accept="image/*"
                  :on-success="uploadSuccess"
                  :on-remove="handleRemove"
                  :limit="3"
                  :on-exceed="handleExceed"
                  with-credentials
                >
                  <el-button size="small" type="primary">
                    {{
                      resData.pay_status === PAY_STATUS_PAID
                        ? "修改回执"
                        : "上传回执"
                    }}
                  </el-button>
                </el-upload>
                <el-button
                  size="small"
                  type="success"
                  :disabled="filesImg.length === 0"
                  @click.stop="confirmUpload"
                  >完成</el-button
                >
              </div>
            </el-table-column>
          </el-table>
          <div
            v-if="resData.pay_status === PAY_STATUS_FAIL"
            style="background: #f3adb6; padding: 10px 24px"
          >
            银行支付失败原因备注：{{ resData.pay_fail_remark || "无" }}
          </div>
          <el-input
            v-if="isShowAgainActivateBtn"
            v-model="remark"
            type="textarea"
            :rows="2"
            maxlength="200"
            show-word-limit
            placeholder="备注信息（200字）"
          >
          </el-input>
        </div>
      </el-col>
    </el-row>
    <!-- 操作日志 -->
    <el-row class="mt-5">
      <el-col style="border: 1px solid #ddd">
        <div class="table-title">
          <div>操作日志</div>
        </div>
        <div v-if="resData.logs" style="margin-bottom: 0">
          <el-table
            :data="resData.logs"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="action_admin"
              label="操作人"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="action_type"
              label="操作方式"
              width="120"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="action_desc"
              label="操作备注"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 分账
import {
  getRefundOrder,
  uploadReceipt,
  reactivate,
} from "@/controller/finance.js";
import apiBaseURL from "@/utils/baseUrl.js";

const PAY_STATUS_UNPAID = "1"; // 待支付
const PAY_STATUS_PAYING = "2"; // 支付中
const PAY_STATUS_FAIL = "3"; // 支付失败
const PAY_STATUS_PAID = "4"; // 已支付
const PAY_TOOL_PAY = "0"; // 转账支付
const PAY_TOOL_RECEIPT = "1"; // 上传回执
const PAY_TOOL_SUB_ACCOUNT = "2";

export default {
  name: "ActivityRefundDetail",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      PAY_STATUS_UNPAID,
      PAY_STATUS_PAYING,
      PAY_STATUS_PAID,
      PAY_STATUS_FAIL,
      PAY_TOOL_PAY,
      PAY_TOOL_RECEIPT,
      PAY_TOOL_SUB_ACCOUNT,
      resData: {
        activity_fee_refund_no: "",
        pay_status_text: "",
        create_time: "",
        activity_goods: [], // 活动退费商品列表
        activity_goods_num: 0, // 活动费退费总件数
        activity_goods_amount: 0, // 活动费退费总金额
        logs: [], // 操作日志
        pay_info: {}, // 支付信息
      },
      filesImg: [],
      filesImgClone: [],
      multipleSelection: [],
      payInfoData: [],
      remark: "", // 备注信息
      updateUpload: true,
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    isShowAgainActivateBtn() {
      return (
        this.resData.pay_status === PAY_STATUS_FAIL &&
        (this.resData.pay_tool === PAY_TOOL_SUB_ACCOUNT ||
          this.resData.pay_tool === PAY_TOOL_PAY)
      );
    },
  },
  created() {
    // this.fetchData();
  },

  methods: {
    fetchData() {
      getRefundOrder({ id: this.$route.params.id })
        .then((data) => {
          this.resData = data;
          if (this.resData.pay_status === PAY_STATUS_PAID) {
            this.filesImgClone = this.resData.receipt_info;
          }
          // this.filesImg = this.resData.receipt_info;
          if (this.resData.pay_status === PAY_STATUS_FAIL) {
            this.payInfoData = this.resData.payee_list;
          } else {
            this.payInfoData = [this.resData.pay_info];
          }
          // this.resData.pay_status === PAY_STATUS_FAIL
          //   ? this.resData.payee_list
          //   : [this.resData.pay_info];
        })
        .catch(this.$noop);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    uploadSuccess(res) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        this.updateUpload = false;
        this.$nextTick(() => {
          this.updateUpload = true;
        });
        if (this.filesImg.length < 3) {
          this.filesImg.push(res.data.origin_files[0]);
        } else {
          this.$message.warning(`最多上传3个回执`);
        }
      }
    },
    delImg(index) {
      this.filesImg.splice(index, 1);
      this.updateUpload = false;
      this.$nextTick(() => {
        this.updateUpload = true;
      });
    },
    handleRemove(file) {
      const index = this.filesImg.indexOf(file.response.data.files[0]);
      if (index > -1) {
        this.filesImg.splice(index, 1);
      }
      this.updateUpload = false;
      this.$nextTick(() => {
        this.updateUpload = true;
      });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeUpload() {
      if (this.filesImg.length > 3) {
        this.$message.warning(`最多上传3个回执`);
      }
    },
    confirmUpload() {
      const uploadArgs = {
        id: this.$route.params.id,
        images: this.filesImg,
      };
      uploadReceipt(uploadArgs)
        .then(() => {
          this.$message({
            message: "上传成功",
            type: "success",
          });
          this.filesImg = [];
          setTimeout(() => {
            this.fetchData();
          }, 200);
        })
        .catch(this.$noop);
    },
    // 重新激活
    handleAgainActivate() {
      if (
        this.resData.pay_tool === PAY_TOOL_PAY &&
        this.multipleSelection.length === 0
      ) {
        this.$message.error("请选择收款人信息");
        return;
      }
      if (this.multipleSelection.length > 1) {
        this.$message.error("仅支持选择一个收款人信息！");
        return;
      }
      this.$confirm("确定重新激活吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const payeeId = this.multipleSelection.map((item) => item.id);
          const params = {
            id: this.$route.params.id,
            payee_id: payeeId.join(","),
            remark: this.remark,
          };
          reactivate(params).then(() => {
            this.$message({
              message: "激活成功",
              type: "success",
            });
            setTimeout(() => {
              this.fetchData();
            }, 200);
          });
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.table-title {
  background: #f3f3f3;
  height: 50px;
  line-height: 30px;
  padding: 0 25px;
  display: flex;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-box {
  width: 50px;
  height: 50px;
  position: relative;
  margin-right: 10px;
}

.img-close {
  color: red;
  font-size: 18px;
  margin-right: 10px;
  position: absolute;
  width: 15px;
  height: 15px;
  right: -5px;
  top: -5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/ActivityRefundDetail.vue